import { render } from "./profile-icon.vue?vue&type=template&id=3b9ffedf"
import script from "./profile-icon.vue?vue&type=script&lang=js"
export * from "./profile-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__